import React from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// COMPONENTS
import SelectMessages from "../select/SelectMessages";

export default function FormSelectMessage({
	inputValue,
	inputOnChange,
	disabledInput,
	displaySelect,
}: {
	inputValue: string;
	inputOnChange: (newValue: string, variableName: string) => void;
	disabledInput: boolean;
	displaySelect: boolean;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const inputOnChangeMessage = (name: string, id: string) => {
		inputOnChange(id, "msg_id");
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className='col-md-12 mt-3'>
			<div className='generalStyles__flex'>
				<div className='generalStyles__inputFlexNameLarge'>
					<span className='generalStyles__inputFlexRequired'>*</span>
					<span>{t("general.message")}</span>
				</div>
				<div className='generalStyles__width100'>
					<SelectMessages
						inputValue={inputValue}
						inputOnChange={inputOnChangeMessage}
						disabledInput={disabledInput}
						displaySelect={displaySelect}
					/>
				</div>
				<div className='generalStyles__infoTooltipIconBlank' />
			</div>
		</div>
	);
}
